import { render } from "./KeHoachNamTable.vue?vue&type=template&id=16715674&ts=true"
import script from "./KeHoachNamTable.vue?vue&type=script&lang=ts"
export * from "./KeHoachNamTable.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__